import { render, staticRenderFns } from "./ConceptChange.vue?vue&type=template&id=6f6ef3bf&scoped=true&"
import script from "./ConceptChange.vue?vue&type=script&lang=js&"
export * from "./ConceptChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ef3bf",
  null
  
)

export default component.exports